/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type GetFrontRichiesteStatoRichiestaItem =
  (typeof GetFrontRichiesteStatoRichiestaItem)[keyof typeof GetFrontRichiesteStatoRichiestaItem];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetFrontRichiesteStatoRichiestaItem = {
  CREATA: 'CREATA',
  BOZZA: 'BOZZA',
  IN_INVIO: 'IN_INVIO',
  INVIATA: 'INVIATA',
  INTEGRATA: 'INTEGRATA',
  CANCELLATA: 'CANCELLATA',
  RICEVUTA: 'RICEVUTA',
  CONCLUSA: 'CONCLUSA',
  PAGAMENTO: 'PAGAMENTO',
  ANNULLATA: 'ANNULLATA',
  ANNULLAMENTO_IN_CORSO: 'ANNULLAMENTO_IN_CORSO',
} as const;
